<div class="upload-file-container">
  <span class="title"><i class="color-blue fa fa-angle-right me-1"></i><span>Favicon</span></span>
  <div class="selector-div-wrapper mb-0">
    <span><small>Tipo de logo</small></span>
    <div class="selector-div">
      <select name="selector" class="selector" [(ngModel)]="tool.default" (change)="checkDefault()">
        <option [ngValue]="false">Cliente</option>
        <option [ngValue]="true">Por defecto 3DDV</option>
      </select>
      <div class="vertical-line"></div>
    </div>
  </div>
  <div *ngIf="!tool.default" class="mb-2">
    <div class="file-content" *ngIf="!tool.file; else fileExisting" (fileDrop)="onFileDropped($event)" fileDropZone>
      <p class="text-drag-file">Arrastrar imagen aquí</p>
      <p class="text-drag-file divisor">— o —</p>
      <input type="file" class="file-uploader" (change)="onFileSelected($event)" #fileUpload />
      <button class="upload-file-btn" (click)="fileUpload.click()">Seleccionar imagen de tu ordenador</button>
    </div>
    <ng-template #fileExisting>
      <div class="file-content">
        <div class="file-box">
          <span>{{ tool.file.name }}</span>
          <button class="element-action-btn" (click)="deleteDroppedFile()">
            <img id="delete" alt="" />
          </button>
        </div>
      </div>
    </ng-template>
  </div>
  <div class="img-container mb-4" *ngIf="faviconPreview">
    <div>
      <span><small>Preview</small></span>
    </div>
    <img class="favicon-preview" [src]="faviconPreview" alt="" />
  </div>
</div>
